import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { OrderInfo } from '../../../models/DTO/orders/orderInfo';

@Injectable({
  providedIn: 'root'
})
export class OrederStateService {

  constructor() { }

  private defaultOrderInfo : OrderInfo = {
    isNewAdrres: false,
    isNewPaymentMethod: false,
    isNewInvoiceAddress: false,
    toCarrierOffice: false,
    toAddress: false,
    personalInvoice: false,
    companyInvoice: false,
    cardPayment: false,
    cashPayment: false,
    cart: undefined,
    checkedCartLines: []
  };

  private _orderInfo = new BehaviorSubject<OrderInfo>(this.defaultOrderInfo);

  public readonly orderInfo$ = this._orderInfo.asObservable();

  get orderInfo() {
    return this._orderInfo.getValue();
  }

  set orderInfo(value: OrderInfo) {
    this._orderInfo.next(value);
  }

  addNewOrderInfo(value: OrderInfo) {
    this.orderInfo = {...value};
  } 

  removeOrderInfo() {
    this.orderInfo = this.defaultOrderInfo;
  }
}
